import * as Sentry from "@sentry/react";

// Initialize Sentry BEFORE any other application code
Sentry.init({
  // Frontend DSN
  dsn: process.env.REACT_APP_SENTRY_DSN,
  
  // Set environment to distinguish between development and production
  environment: process.env.NODE_ENV || "development",
  
  // Set the release version for better issue grouping
  release: process.env.REACT_APP_VERSION || require('../package.json').version,
  
  // Enable performance monitoring
  integrations: [
    // Browser tracing integration for performance monitoring
    Sentry.browserTracingIntegration({
      tracingOrigins: [
        "localhost",
        /^\//,
      ],
    }),
    // Session replay integration to capture user interactions
    // RGPD: defaults sécurisés pour éviter la capture de PII (IBAN, clients,
    // montants) dans cet ERP CRM/facturation (SEC-10)
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // Capture performance monitoring data (10% of transactions)
  tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
  
  // Configure session replay sampling
  replaysSessionSampleRate: 0.1,  // 10% of sessions
  replaysOnErrorSampleRate: 1.0,  // 100% of sessions with errors
  
  // Send default PII if you have user consent
  sendDefaultPii: false,
  
  // Enable debug mode for development
  debug: process.env.NODE_ENV === "development",
  
  // Filter out certain errors
  beforeSend(event, hint) {
    // Filter out 404 errors from ignored resources
    if (event.exception) {
      const error = hint.originalException;
      if (error && error.message && (
        error.message.includes("404") ||
        error.message.includes("ResizeObserver") ||
        error.message.includes("Loading chunk")
      )) {
        return null;
      }
    }
    return event;
  },
  
  // Ignore common non-critical errors
  ignoreErrors: [
    "ResizeObserver loop",
    "Non-Error promise rejection",
    "Network request failed",
    "Load failed",
  ],
});

export default Sentry;
